import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import SetDefaultValues from '../../SetupAccount/SetDefaultValues';

interface EditBrandProps {
  isOpen?: boolean;
  userBrandId?: string | null;
  toggle: () => void;
}

const EditBrand: React.FC<EditBrandProps> = ({ isOpen, userBrandId, toggle }) =>
  userBrandId ? (
    <Modal centered isOpen={isOpen} toggle={toggle} wrapClassName="modal-dark" size="lg">
      <ModalHeader toggle={toggle} />
      <ModalBody>
        <SetDefaultValues accountView userBrandId={userBrandId} />
      </ModalBody>
    </Modal>
  ) : null;

export default EditBrand;
